import React from 'react';

const Image = ({ 
  src = 'https://via.placeholder.com/800x400', 
  alt = 'Image', 
  caption = '',
  rounded = 'md',
  className = '' 
}) => {
  const roundedClasses = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    full: 'rounded-full',
  };

  return (
    <figure className={className}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-auto ${roundedClasses[rounded]}`}
      />
      {caption && (
        <figcaption className="text-sm text-muted-foreground mt-2 text-center">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

Image.builderConfig = {
  props: {
    src: {
      type: 'image',
      label: 'Image URL',
      default: 'https://via.placeholder.com/800x400',
    },
    alt: {
      type: 'text',
      label: 'Alt Text',
      default: 'Image',
    },
    caption: {
      type: 'text',
      label: 'Caption',
      default: '',
    },
    rounded: {
      type: 'select',
      label: 'Border Radius',
      default: 'md',
      options: [
        { value: 'none', label: 'None' },
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
        { value: 'xl', label: 'Extra Large' },
      ],
    },
  },
};

export default Image;
